__turbopack_context__.v({
  "icon": "pagination-module-scss-module__nO6MwG__icon",
  "inner": "pagination-module-scss-module__nO6MwG__inner",
  "pagination": "pagination-module-scss-module__nO6MwG__pagination",
});
